import {useEffect, useState} from "react";
import React from "react";

const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const documentChangeHandler = () => setMatches(mediaQueryList.matches);

        mediaQueryList.addListener(documentChangeHandler);

        return () => {
            mediaQueryList.removeListener(documentChangeHandler);
        };
    }, [query]);

    return matches;
};

const RectangleCountdownTimer = ({targetDate, width = "100%", ...props}) => {
    const [timeLeft, setTimeLeft] = React.useState(null);
    const isBigScreen = useMediaQuery("(min-width: 768px)");

    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now();
            const distance = new Date(targetDate) - now;
            if (distance > 0) {
                setTimeLeft({
                    days: Math.floor(distance / (1000 * 60 * 60  * 24)),
                    hours: Math.floor((distance / (1000 * 60 * 60 )) % 24),
                    minutes: Math.floor((distance / (1000 * 60)) % 60),
                    seconds: Math.floor((distance / 1000) % 60),
                });
            } else{
                clearInterval(interval);
            }
        }, 100);

        return () => clearInterval(interval);
    }, [targetDate]);

    return (
        <>
        {timeLeft ? (
            <div className={"rotating-border"} style={{...props, textAlign: "center", fontSize: isBigScreen ? "3em" : "2em", fontFamily: 'Arial', fontWeight: 'semibold', width: width}}>
                <div className={"text-[#0987F3] bg-[#DAE1FF]"} style={{background: "transparent", borderRadius: '2.25em', padding: '0.4em', display: "flex", flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center'}}>
                    <span style={{display: "flex", flexDirection: "column", marginRight: "0.2em"}}><span>{timeLeft.days.toString().padStart(2, "0")}</span> <span style={{fontWeight: 'lighter', opacity: "60%", fontSize: "0.6em"}}>ӨДӨР</span></span> :
                    <span style={{display: "flex", flexDirection: "column", margin: "0 0.2em"}}><span>{timeLeft.hours.toString().padStart(2, "0")}</span> <span style={{fontWeight: 'lighter', opacity: "60%", fontSize: "0.6em"}}>ЦАГ</span></span> :
                    <span style={{display: "flex", flexDirection: "column", margin: "0 0.2em"}}><span>{timeLeft.minutes.toString().padStart(2, "0")}</span> <span style={{fontWeight: 'lighter', opacity: "60%", fontSize: "0.6em"}}>МИН</span></span> :
                    <span style={{display: "flex", flexDirection: "column", marginLeft: "0.2em"}}><span>{timeLeft.seconds.toString().padStart(2, "0")}</span> <span style={{fontWeight: 'lighter', opacity: "60%", fontSize: "0.6em"}}>СЕК</span></span>
                </div>
            </div>
            ) :
            new Date(targetDate).toLocaleString().split(",")[0] === new Date().toLocaleString().split(",")[0] ?(
                <div style={{...props}}>
                    <p className={"gradient-text text-[3rem] mobile:text-[2rem]"}>ТОХИРОЛ ӨНӨӨДӨР</p>
                </div>
            ) : (
                <div style={{...props}}>
                    <p className={"gradient-text text-[3rem] mobile:text-[2rem]"}>ТУН УДАХГҮЙ</p>
                </div>
            )
        }
        </>
    )
}

export default RectangleCountdownTimer;